import { DateTime } from 'luxon';

export default function dateIsAfter(date1: DateTime, date2: DateTime): boolean {
  return date2.startOf('day').diff(date1.startOf('day'), 'days').days < 0;
}
